export enum AppointmentsAnalyticsEnum {
  APPOINTMENTS_CLICK_EXPORT_GUIDE = '[PAC WEB] Agendamentos - Paciente clicou em "Exportar guia"',
}
